<template>
  <div class="app-layout">
    <header class="app-header">
      <RouterLink class="brand" :to="routeStore.firstPath || '/login'" aria-label="IVUSmart">
        <img src="/static/img/logo-top.png" alt="IVUSmart" />
      </RouterLink>
      <nav class="app-nav" aria-label="主导航">
        <div v-for="item in navigation" :key="item.activePath" class="nav-group">
          <RouterLink
            class="nav-link"
            :class="{ active: isActive(item) }"
            :to="item.path"
            :aria-current="isActive(item) ? 'page' : undefined"
          >
            <img v-if="item.icon" :src="`/static/img/${item.icon}`" alt="" />
            <span>{{ item.title }}</span>
            <el-icon v-if="item.children.length" class="nav-arrow"><ArrowDown /></el-icon>
          </RouterLink>
          <div v-if="item.children.length" class="sub-nav">
            <RouterLink
              v-for="child in item.children"
              :key="child.activePath"
              :to="child.path"
              :class="{ active: isActive(child) }"
            >
              {{ child.title }}
            </RouterLink>
          </div>
        </div>
      </nav>
        <el-button
          v-if="isWindows"
          class="viewer-button"
          :loading="viewerOpening === 'image'"
          :disabled="viewerOpening !== null"
          @click="openViewer('image')"
          >打开Image Viewer</el-button
        >
        <el-button
          v-if="isWindows"
          class="viewer-button"
          :loading="viewerOpening === 'avvigo'"
          :disabled="viewerOpening !== null"
          @click="openViewer('avvigo')"
          >打开Avvigo Viewer</el-button
        >
      <div class="viewer-actions">

        <el-tooltip class="box-item" effect="light" placement="bottom">
        <template #content>压缩记录
        </template>
        <el-icon class="compression" @click="openCompressionRecords">
        <svg t="1790644766593" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4836" width="32" height="32"><path d="M256 768v42.666667a42.666667 42.666667 0 0 0 37.674667 42.368L298.666667 853.333333h469.333333v-85.333333H256z m206.506667-282.026667H306.048v36.138667h99.584l-112.298667 138.666667v38.954666h173.696v-36.010666h-121.6l117.077334-144.213334v-33.578666z m73.642666 0h-43.178666v213.76h43.178666v-213.76z m110.421334 0H577.28v213.76h43.178667v-80.64h28.16c29.269333 0 29.269333 0 44.757333-3.072 11.349333-2.474667 11.349333-2.474667 22.357333-10.112 11.008-7.68 11.008-7.68 18.176-21.077333 7.125333-13.44 7.125333-13.44 7.125334-33.109333 0-25.514667 0-25.514667-12.373334-41.642667s-12.373333-16.128-30.762666-20.906667c-10.666667-2.858667-10.666667-2.858667-42.922667-3.2h-8.405333z m-5.290667 36.138667c23.338667 0 23.338667 0 31.061333 1.450667 10.538667 1.92 10.538667 1.92 17.365334 9.472 6.826667 7.594667 6.826667 7.594667 6.826666 19.242666 0 9.514667 0 9.514667-4.864 16.64-4.864 7.168-4.864 7.168-13.482666 10.496-8.576 3.370667-8.576 3.370667-34.133334 3.370667h-23.594666v-60.672h20.821333zM682.666667 170.666667v85.333333h85.333333l-85.333333-85.333333z m85.333333 170.666666h-170.666667V170.666667H256v256H170.666667V85.333333h512l170.666666 170.666667v170.666667h85.333334v341.333333h-85.333334v170.666667H298.666667a128 128 0 0 1-128-128v-42.666667H85.333333v-341.333333h682.666667V341.333333z" p-id="4837" fill="#ffffff"></path></svg>
        </el-icon>
      </el-tooltip>
      
      </div>
      <div class="app-account">
        <el-dropdown trigger="click" @command="handleAccountCommand">
          <button type="button" class="account-trigger">
            <img src="/static/img/user-circle.png" alt="" />
            <span>{{ auth.user?.userName || '未登录用户' }}</span>
            <el-icon><ArrowDown /></el-icon>
          </button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="password">修改密码</el-dropdown-item>
              <el-dropdown-item divided command="system">关于系统</el-dropdown-item>
              <el-dropdown-item divided command="export">导出日志</el-dropdown-item>
              <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </header>
    <main class="app-main">
      <router-view />
    </main>
    <footer class="app-footer">© 2026 Beyondsoft Corporation. All Rights Reserved.</footer>

    <el-dialog v-model="viewerDialogVisible" title="打开失败" width="50%" :close-on-click-modal="false">
      <div class="viewer-dialog-body">
        <div class="viewer-dialog-remind">系统未安装对应的软件或未注册快捷协议，请按照以下步骤安装和注册协议：</div>
        <div class="viewer-step">
          <span class="viewer-step-num">第一步：</span>
          <span class="viewer-step-text"
            >下载并安装{{ currentViewer.name }}，<a :href="currentViewer.installUrl || 'javascript:;'" target="_blank"
              >点击此处下载安装包</a
            ></span
          >
        </div>
        <div class="viewer-step">
          <span class="viewer-step-num">第二步：</span>
          <span class="viewer-step-text"
            >注册软件协议，<a :href="currentViewer.regUrl || 'javascript:;'" target="_blank">点此下载如下脚本</a>并<span
              class="viewer-admin"
              >以管理员身份</span
            >运行脚本，运行完成后请点击系统按钮重试</span
          >
        </div>
        <div class="viewer-dialog-remind">
          如还是未能打开，请联系运维人员，电话400-****-****，或发送邮件到此邮箱***.com
        </div>
        <div class="viewer-step-text">
          <span class="viewer-admin">注：</span
          >卸载该软件后请务必点击右上角头像，选择“关于系统”，下载协议清理脚本并以管理员身份运行脚本。清理完成后刷新页面即可。
        </div>
      </div>
      <template #footer><el-button type="primary" @click="viewerDialogVisible = false">我知道了</el-button></template>
    </el-dialog>

    <el-dialog
      v-model="passwordDialogVisible"
      :title="forcePasswordChange ? '首次登录，请修改密码' : '修改密码'"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="!forcePasswordChange"
      :show-close="!forcePasswordChange"
      :before-close="beforePasswordDialogClose"
    >
      <el-form ref="passwordFormRef" :model="passwordForm" :rules="passwordRules" label-position="top">
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="passwordForm.oldPassword" type="password" show-password autocomplete="current-password" />
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input v-model="passwordForm.password" type="password" show-password autocomplete="new-password" />
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input v-model="passwordForm.confirmPassword" type="password" show-password autocomplete="new-password" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button v-if="!forcePasswordChange" @click="passwordDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="passwordSubmitting" @click="submitPassword">保存</el-button>
      </template>
    </el-dialog>

    <el-dialog v-model="aboutDialogVisible" title="关于系统" width="480px" :close-on-click-modal="false">
      <el-descriptions :column="1" border>
        <el-descriptions-item label="系统版本">
          {{ aboutInfo.version || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="过期日期">
          {{ aboutInfo.expiryDate || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="协议清理脚本">
          <a style="color: #0052d9" :href="cleanupUrl" target="_blank">点此下载</a>协议清理脚本并<span style="color: #f00">以管理员身份</span
          >运行脚本
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { computed, inject, reactive, ref, watch } from 'vue'
import type { FormInstance, FormRules } from 'element-plus'
import { ElMessage } from 'element-plus'
import { ArrowDown } from '@element-plus/icons-vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useRouteStore } from '@/stores/route'
import { clearAuthorizedRoutes } from '@/router/authorized'
import { getAuthSecret, getLicenseAbout, logout, updatePassword } from '@/services/auth/auth'
import { exportSystemLog } from '@/services/system/system-log'
import { encryptWithSm2PublicKey } from '@/core/crypto/sm2'
import { saveDownload } from '@/core/http/download'
import { runtimeConfigKey, type RuntimeConfig } from '@/core/config/runtime'
import { loadSession } from '@/core/storage/session'
import '@/core/router/initial-navigation'
const session = loadSession()

const auth = useAuthStore()
const runtimeConfig = inject<RuntimeConfig>(runtimeConfigKey)
const routeStore = useRouteStore()
const route = useRoute()
const router = useRouter()
const navigation = computed(() => routeStore.navigation)
const isWindows = typeof navigator !== 'undefined' && /\bWindows\b/i.test(navigator.userAgent)
const passwordDialogVisible = ref(false)
const forcePasswordChange = computed(() => auth.needModify)
const passwordSubmitting = ref(false)
const passwordFormRef = ref<FormInstance>()
const passwordForm = reactive({ oldPassword: '', password: '', confirmPassword: '' })
const aboutDialogVisible = ref(false)
const aboutLoading = ref(false)
const aboutInfo = reactive({ version: '', expiryDate: '' })
const viewerDialogVisible = ref(false)
const viewerOpening = ref<keyof typeof viewerApps | null>(null)
const currentViewer = ref({ name: '', installUrl: '', regUrl: '' })
const viewerBaseUrl = runtimeConfig?.viewerBaseUrl || '/install'
const cleanupUrl = `${viewerBaseUrl}/clean_register.bat`
const viewerApps = {
  image: {
    name: 'Image Viewer',
    protocol: 'imageviewer://open',
    installUrl: `${viewerBaseUrl}/ImageViewer.exe`,
    regUrl: `${viewerBaseUrl}/register_imageviewer.bat`
  },
  avvigo: {
    name: 'Avvigo Viewer',
    protocol: 'avvigoviewer://open',
    installUrl: `${viewerBaseUrl}/AVVIGO-Viewer-Setup.exe`,
    regUrl: `${viewerBaseUrl}/register_avvigoviewer.bat`
  }
}

const passwordAllowedPattern = /^[A-Za-z0-9()`!@#$%^&*_\x5C+=|{}\x5B\x5D:;'<>,.?-]+$/
const passwordSpecialCharacterPattern = /[()`!@#$%^&*_\x5C+=|{}\x5B\x5D:;'<>,.?-]/

const passwordRules: FormRules = {
  oldPassword: [
    { required: true, message: '请输入原密码', trigger: 'blur' },
    { min: 8, max: 18, message: '密码长度为 8-18 位', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入新密码', trigger: 'blur' },
    {
      validator: (_rule, value, callback) => {
        const password = typeof value === 'string' ? value : ''
        if (!password) {
          callback()
          return
        }
        if (password.length < 8 || password.length > 18) {
          callback(new Error('新密码长度必须为 8-18 位'))
          return
        }
        if (/\s/.test(password)) {
          callback(new Error('新密码不能包含空格'))
          return
        }
        if (!passwordAllowedPattern.test(password)) {
          callback(new Error("请输入指定特殊字符()`!@#$%^&*_\x5C+=|{}\x5B\x5D:;'<>,.?-"))
          return
        }
        if (password === passwordForm.oldPassword) {
          callback(new Error('新密码不能与原密码相同'))
          return
        }

        const categoryCount = [
          /[A-Z]/.test(password),
          /[a-z]/.test(password),
          /[0-9]/.test(password),
          passwordSpecialCharacterPattern.test(password)
        ].filter(Boolean).length
        if (categoryCount < 3) {
          callback(new Error('新密码必须满足大写字母、小写字母、数字、特殊字符中的至少三类'))
          return
        }
        callback()
      },
      trigger: 'blur'
    }
  ],
  confirmPassword: [
    { required: true, message: '请输入确认新密码', trigger: 'blur' },
    {
      validator: (_rule, value, callback) => {
        if (value !== passwordForm.password) {
          callback(new Error('两处密码不一致'))
          return
        }
        callback()
      },
      trigger: 'blur'
    }
  ]
}

watch(
  forcePasswordChange,
  (required) => {
    if (required) openPasswordDialog()
  },
  { immediate: true }
)

function isActive(item: { activePath: string }) {
  return route.path === item.activePath || route.path.startsWith(`${item.activePath}/`)
}

function openCompressionRecords() {
  void router.push({ name: 'ivus-compression-records' })
}

function openViewer(type: keyof typeof viewerApps) {
  if (viewerOpening.value) return
  const app = viewerApps[type]
  viewerOpening.value = type
  currentViewer.value = app
  let settled = false
  let launchTimeout = 0
  let iframe: HTMLIFrameElement | undefined

  const cleanup = () => {
    if (launchTimeout) window.clearTimeout(launchTimeout)
    window.removeEventListener('blur', handleLaunch)
    iframe?.remove()
  }

  const finish = (showFailureDialog: boolean) => {
    if (settled) return
    settled = true
    cleanup()
    viewerOpening.value = null
    if (showFailureDialog) viewerDialogVisible.value = true
  }

  const handleLaunch = () => finish(false)
  const handleFailure = () => finish(true)

  launchTimeout = window.setTimeout(handleFailure, 2500)
  window.addEventListener('blur', handleLaunch)
  try {
    iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = app.protocol
    iframe.onload = handleLaunch
    iframe.onerror = handleFailure
    document.body.appendChild(iframe)
  } catch {
    handleFailure()
  }
}

function handleAccountCommand(command: string) {
  if (command === 'password') {
    openPasswordDialog()
  } else if (command === 'logout') {
    void handleLogout()
  } else if (command === 'system') {
    void openAbout()
  } else if (command === 'export') {
    void handleExportLogs()
  }
}

async function handleExportLogs() {
  try {
    const result = await exportSystemLog()
    saveDownload(result, 'system-log-export')
  } catch (error) {
    ElMessage.error(error instanceof Error && error.message ? error.message : '日志导出失败，请稍后重试。')
  }
}

function openPasswordDialog() {
  passwordForm.oldPassword = ''
  passwordForm.password = ''
  passwordForm.confirmPassword = ''
  passwordFormRef.value?.clearValidate()
  passwordDialogVisible.value = true
}

function beforePasswordDialogClose(done: () => void) {
  if (!forcePasswordChange.value) done()
}

async function openAbout() {
  if (aboutLoading.value) return
  aboutLoading.value = true
  try {
    const result = await getLicenseAbout()
    aboutInfo.version = result?.version || ''
    aboutInfo.expiryDate = result?.expiryDate || ''
    aboutDialogVisible.value = true
  } catch (error) {
    ElMessage.error(error instanceof Error && error.message ? error.message : '系统信息加载失败，请稍后重试')
  } finally {
    aboutLoading.value = false
  }
}

async function submitPassword() {
  const valid = await passwordFormRef.value?.validate().catch(() => false)
  if (!valid) return
  passwordSubmitting.value = true
  try {
    const secret = await getAuthSecret()
    const payload = JSON.stringify({
      userId: session?.userId,
      oldPassword: passwordForm.oldPassword,
      newPassword: passwordForm.password
    })
    const encryptedPayload = encryptWithSm2PublicKey(payload, secret.publicKey)
    await updatePassword(encryptedPayload, secret.flag)
    ElMessage.success('密码修改成功，请重新登录')
    passwordDialogVisible.value = false
    await handleLogout()
  } catch (error) {
    ElMessage.error(error instanceof Error && error.message ? error.message : '密码修改失败，请稍后重试')
  } finally {
    passwordSubmitting.value = false
  }
}

async function handleLogout() {
  try {
    if (auth.isAuthenticated) await logout()
  } catch {
    // A local session must still be cleared when the server is unavailable.
  } finally {
    auth.clearSession()
    routeStore.clear()
    clearAuthorizedRoutes()
    await router.replace('/login')
  }
}
</script>

<style scoped>
.app-layout {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: #f1f2f9;
  color: rgba(0, 0, 0, 0.9);
}

.app-header {
  display: flex;
  align-items: center;
  height: 54px;
  flex: 0 0 54px;
  min-width: 0;
  padding: 0 var(--page-gutter);
  color: #fff;
  background: #0052d9;
}

.brand {
  display: flex;
  flex: 0 0 200px;
  align-items: center;
  height: 100%;
}

.brand img {
  max-width: 150px;
  max-height: 32px;
}

.app-nav {
  display: flex;
  align-items: stretch;
  gap: 0;
  flex: 1 1 auto;
  height: 100%;
  min-width: 0;
}

.viewer-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 10px;
  margin: 0 10px;
}

.viewer-button.el-button {
  width: auto;
  height: 32px;
  padding: 0 16px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 3px;
  color: #fff;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
}

.viewer-button.el-button:hover,
.viewer-button.el-button:focus {
  border-color: #fff;
  color: #fff;
  background: rgba(255, 255, 255, 0.15);
}

.viewer-button.el-button.is-disabled,
.viewer-button.el-button.is-disabled:hover {
  border-color: rgba(255, 255, 255, 0.35);
  color: rgba(255, 255, 255, 0.65);
  background: transparent;
}

.compression {
  font-size: 24px;
  cursor: pointer;
}
.nav-group {
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
}

.nav-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  margin-right: 18px;
  padding: 5px 10px;
  color: rgba(255, 255, 255, 0.82);
  text-decoration: none;
  font-size: 14px;
  line-height: 22px;
  white-space: nowrap;
}

.nav-link img {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.nav-link:hover,
.nav-link.active,
.nav-group:focus-within .nav-link {
  color: #fff;
  background: #012965;
  border-radius: 3px;
}

.nav-arrow {
  font-size: 12px;
}

.sub-nav {
  position: absolute;
  z-index: 20;
  top: 54px;
  left: 0;
  display: none;
  /* min-width: 150px; */
  padding: 6px 0;
  background: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.14);
}

.nav-group:hover .sub-nav,
.nav-group:focus-within .sub-nav {
  display: grid;
}

.sub-nav a {
  padding: 10px 30px;
  color: rgba(0, 0, 0, 0.75);
  text-decoration: none;
  white-space: nowrap;
  font-size: 14px;
}

.sub-nav a:hover,
.sub-nav a.active {
  color: #0052d9;
  background: #f1f5ff;
}

.app-account {
  display: flex;
  flex: 0 1 auto;
  min-width: 0;
  align-items: center;
  justify-content: flex-end;
}

.account-trigger {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: 0;
  color: #fff;
  background: transparent;
  cursor: pointer;
  font: inherit;
}

.account-trigger span {
  overflow: hidden;
  max-width: 88px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-trigger img {
  display: block;
  width: 26px;
  height: 26px;
}

.app-main {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

.app-footer {
  flex: 0 0 auto;
  padding: 15px 0;
  color: #000;
  text-align: center;
  font-size: 16px;
  font-weight: 200;
}

.viewer-dialog-body {
  color: #333;
  font-size: 14px;
  line-height: 24px;
}

.viewer-dialog-remind {
  margin-bottom: 10px;
}

.viewer-step {
  display: flex;
  margin-bottom: 10px;
}

.viewer-step-num {
  white-space: nowrap;
  font-weight: 700;
}

.viewer-step-text {
  flex: 1;
}

.viewer-admin {
  color: #f00;
}

.viewer-dialog-body a {
  color: #0052d9;
}

@media (max-width: 1365px) {
  .brand {
    flex-basis: 160px;
  }

  .nav-link {
    margin-right: 10px;
    padding-right: 8px;
    padding-left: 8px;
  }
}

@media (max-width: 1279px) {
  .app-header {
    padding-right: 40px;
    padding-left: 40px;
  }

  .brand {
    flex-basis: 120px;
  }

  .brand img {
    max-width: 138px;
    margin-right: 20px;
  }

  .nav-link {
    gap: 4px;
    margin-right: 2px;
    padding-right: 8px;
    padding-left: 5px;
  }

  .viewer-actions {
    gap: 6px;
    margin: 10px;
  }

  .viewer-button.el-button {
    min-width: 118px;
    padding-right: 4px;
    padding-left: 4px;
  }

  .account-trigger {
    gap: 5px;
  }

  .account-trigger span {
    max-width: 60px;
  }
}
</style>
